import * as ACTIONS_TYPE from './actionsTypes';

export const setTipoMercado = (tipoMercadoVisa, tipoMercadoSafetyPay, tipoMercadoPagoLink) => {
    return {
        type: ACTIONS_TYPE.SET_TIPO_MERCADO,
        payload: {
            tipoMercadoVisa,
            tipoMercadoSafetyPay,
            tipoMercadoPagoLink
        }
      }
}

export const setMensajeError = (mensajeError) => {
    return {
        type: ACTIONS_TYPE.SET_MENSAJE_ERROR,
        payload: {
            mensajeError
        }
    }
}

export const setDataVisa = (data) => {
    return {
        type: ACTIONS_TYPE.SET_DATA_VISA,
        payload: {
            data
        }
    }
}

export const setDataSafetyPay = (data) => {
    return {
        type: ACTIONS_TYPE.SET_DATA_SAFETYPAY,
        payload: {
            data
        }
    }
}

export const setDataPagoLink = (data) => {
    return {
        type: ACTIONS_TYPE.SET_DATA_PAGOLINK,
        payload: {
            data
        }
    }
}